import { useMutation } from "@tanstack/react-query";
import { verifyFile } from "@services/fileVerification";

export const useFileVerification = () => {
  return useMutation(
    ({ file, isEncrypted }: { file: File; isEncrypted: boolean }) =>
      verifyFile({ file, isEncrypted })
  );
};
